/* Silver Revival Co. — storefront behaviour. No dependencies. */
(function () {
  'use strict';
  var SR = window.SR = window.SR || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  SR.formatMoney = function (cents) {
    var fmt = SR.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return withDec.replace('.', ',');
      return withDec;
    });
  };

  /* ---------- Cart API (Shopify AJAX API; the preview swaps this for an in-memory version) ---------- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  SR.cartApi = SR.cartApi || {
    get: function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (id, qty) {
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); });
    },
    change: function (key, qty) {
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    }
  };

  /* ---------- Header ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var menuBtn = $('.menu-toggle'), mobileNav = $('#MobileNav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.hidden; mobileNav.hidden = !open; menuBtn.setAttribute('aria-expanded', String(open));
    });
    $$('a', mobileNav).forEach(function (a) { a.addEventListener('click', function () { mobileNav.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); }); });
  }

  /* ---------- Polish vs plating diagram ---------- */
  $$('[data-layers]').forEach(function (box) {
    var tabs = $$('[role="tab"]', box), cap = $('[data-layers-caption]', box);
    var select = function (tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
      box.setAttribute('data-state', tab.dataset.state);
      if (cap) cap.innerHTML = '<b>' + tab.dataset.title + '</b><span>' + tab.dataset.body + '</span>';
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); select(n); }
      });
    });
    var initial = $('[aria-selected="true"]', box) || tabs[0];
    if (initial) select(initial);
  });

  /* ---------- Compatibility checker ---------- */
  $$('[data-checker]').forEach(function (box) {
    var out = $('.verdict', box);
    var labels = { yes: box.dataset.labelYes, test: box.dataset.labelTest, no: box.dataset.labelNo, polish: box.dataset.labelPolish };
    $$('[data-metal]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-metal]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        var v = btn.dataset.verdict;
        out.setAttribute('data-verdict', v);
        $('.verdict__label', out).textContent = labels[v] || '';
        $('.verdict__title', out).textContent = btn.dataset.title;
        $('.verdict__body', out).textContent = btn.dataset.body;
        $('.verdict__empty', out).hidden = true;
        $$('[data-show-for]', out).forEach(function (el) { el.hidden = el.dataset.showFor.split(' ').indexOf(v) === -1; });
        var r = out.getBoundingClientRect();
        if (r.bottom > window.innerHeight) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  });

  /* ---------- Before / after sliders ---------- */
  $$('.ba__range').forEach(function (r) {
    var frame = r.closest('.ba__frame');
    var set = function () { frame.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', set); set();
  });

  /* ---------- Product form ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var qtyInput = $('input[name="quantity"]', form);
    var priceEl = $('[data-price]', form.closest('[data-product]'));
    var chip = $('[data-atc-price]', form);
    var sticky = $('[data-sticky-price]');
    var current = function () { var c = $('input[name="id"]:checked', form) || $('[name="id"]', form); return c; };
    var refresh = function () {
      var c = current(); if (!c) return;
      var price = Number(c.dataset.price || 0) * Math.max(1, Number(qtyInput ? qtyInput.value : 1));
      var unit = SR.formatMoney(c.dataset.price);
      if (priceEl) priceEl.textContent = unit;
      if (chip) chip.textContent = SR.formatMoney(price);
      if (sticky) sticky.textContent = unit + (c.dataset.label ? ' · ' + c.dataset.label : '');
    };
    $$('input[name="id"]', form).forEach(function (i) { i.addEventListener('change', refresh); });
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, Math.min(99, Number(qtyInput.value || 1) + Number(b.dataset.qty)));
        qtyInput.value = v; refresh();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', refresh);
    refresh();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type="submit"]', form), msg = $('[data-form-message]', form), c = current();
      if (!c) return;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.hidden = true;
      SR.cartApi.add(c.value, Math.max(1, Number(qtyInput ? qtyInput.value : 1)))
        .then(function () { return SR.refreshCart(true); })
        .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } })
        .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
    });
  });

  /* ---------- D. Bottom dock: add to bag ---------- */
  var stickyBar = $('[data-sticky-atc]'), mainAtc = $('[data-main-atc]');
  if (stickyBar) {
    // Live at the end of <body> so no wrapper (section, app block, editor frame) can trap or clip the fixed bar.
    if (stickyBar.parentNode !== document.body) document.body.appendChild(stickyBar);
    document.body.classList.add('has-sticky-atc');
    // Shopify's preview bar sits on the bottom edge on phones; lift the dock above it when it's present.
    var liftDock = function () {
      var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      var h = 0;
      if (pb) { var r = pb.getBoundingClientRect(); if (r.height && r.top > window.innerHeight / 2) h = Math.round(window.innerHeight - r.top); }
      document.documentElement.style.setProperty('--dock-lift', h + 'px');
    };
    liftDock(); window.addEventListener('resize', liftDock); setTimeout(liftDock, 1500); setTimeout(liftDock, 4000);
    var addBtn = $('[data-dock-add]', stickyBar);
    if (addBtn) addBtn.addEventListener('click', function () {
      var f = mainAtc && mainAtc.closest('form');
      if (!f) { window.location.hash = 'buy'; return; }
      if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var lastFocus = null;
  SR.openCart = function () {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var c = $('.drawer__close', drawer); if (c) c.focus(); }, 50);
  };
  SR.closeCart = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var jarThumb = function () { var t = $('#JarThumbTemplate'); return t ? t.innerHTML : ''; };
  SR.renderCart = function (cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    var list = $('[data-cart-items]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    if (!cart.items.length) {
      list.innerHTML = '<div class="drawer__empty"><p>Your bag is empty.</p><a class="btn btn--ghost" href="#buy" data-close-cart>Shop Silver Revival</a></div>';
      foot.hidden = true;
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var img = jarThumb();
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="line-item__variant">' + esc(it.variant_title) + '</div>' : '';
        return '<div class="line-item" data-key="' + esc(it.key) + '">' +
          '<div class="line-item__img">' + img + '</div>' +
          '<div><div class="line-item__title">' + esc(it.product_title) + '</div>' + variant +
          '<div class="line-item__qty"><button type="button" data-change="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-change="1" aria-label="Increase quantity">+</button></div>' +
          '<div><button type="button" class="line-item__remove" data-remove>Remove</button></div></div>' +
          '<div class="line-item__price">' + SR.formatMoney(it.final_line_price) + '</div></div>';
      }).join('');
      foot.hidden = false;
      $('[data-cart-total]', drawer).textContent = SR.formatMoney(cart.total_price);
    }
    var ship = $('[data-ship]', drawer), threshold = Number(drawer.dataset.freeShipping || 0);
    if (ship) {
      if (!threshold || !cart.items.length) { ship.hidden = true; }
      else {
        ship.hidden = false;
        var left = threshold - cart.total_price;
        $('[data-ship-text]', ship).textContent = left > 0 ? 'You’re ' + SR.formatMoney(left) + ' away from free shipping.' : 'Your order ships free.';
        $('[data-ship-bar]', ship).style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
      }
    }
  };
  SR.refreshCart = function (open) {
    return SR.cartApi.get().then(function (cart) { SR.renderCart(cart); if (open) SR.openCart(); return cart; });
  };
  if (drawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-cart]');
      if (opener) { e.preventDefault(); SR.refreshCart(true); return; }
      if (e.target.closest('[data-close-cart]')) { SR.closeCart(); return; }
      var li = e.target.closest('.line-item');
      if (li && drawer.contains(li)) {
        var key = li.dataset.key, q = Number($('.line-item__qty span', li).textContent);
        var ch = e.target.closest('[data-change]');
        if (ch) SR.cartApi.change(key, Math.max(0, q + Number(ch.dataset.change))).then(SR.renderCart);
        if (e.target.closest('[data-remove]')) SR.cartApi.change(key, 0).then(SR.renderCart);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') SR.closeCart();
      if (e.key === 'Tab') {
        var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', $('.drawer__panel', drawer)).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    SR.refreshCart(false).catch(function () {});
  }

  /* ---------- Section navigation: B progress line (top), C contents drawer (side), D dock jump menu (bottom) ---------- */
  (function () {
    var nav = $('[data-secnav]');
    var drawer = $('[data-contents]');
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer); // escape the sticky bar's stacking

    // Numbers match the "No. 01" section labels (only numbered labels count)
    var numbered = $$('main .hallmark:not(.hallmark--plain)');
    var numFor = function (el) {
      var h = el && el.querySelector('.hallmark:not(.hallmark--plain)');
      var i = h ? numbered.indexOf(h) : -1;
      return i < 0 ? '' : 'No. ' + String(i + 1).padStart(2, '0');
    };

    var items = nav ? $$('[data-secnav-link]', nav).map(function (a) {
      var id = a.getAttribute('href').slice(1), el = document.getElementById(id);
      if (!el) a.parentNode.hidden = true;
      return { id: id, a: a, el: el, label: $('.secnav__label', a).textContent.trim(), num: numFor(el) };
    }).filter(function (x) { return x.el; }) : [];

    // C. Contents drawer
    var lastFocus = null;
    var openContents = function () {
      if (!drawer) { window.location.href = '/#contents'; return; }
      lastFocus = document.activeElement;
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var c = $('[data-close-contents].icon-btn', drawer); if (c) c.focus(); }, 60);
    };
    var closeContents = function () {
      if (!drawer) return;
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    if (drawer) {
      $$('[data-contents-item]', drawer).forEach(function (li) {
        var el = document.getElementById(li.getAttribute('data-contents-item'));
        if (!el) { li.hidden = true; return; }
        $('[data-contents-num]', li).textContent = numFor(el);
      });
      var clist = $('.contents__list', drawer);
      $$('[data-contents-item]', drawer).filter(function (li) { return !li.hidden && !$('[data-contents-num]', li).textContent; }).reverse().forEach(function (li) { clist.insertBefore(li, clist.firstChild); });
      drawer.addEventListener('click', function (e) { if (e.target.closest('[data-close-contents]')) closeContents(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeContents(); });
    }
    $$('[data-open-contents]').forEach(function (b) {
      b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openContents(); } });
    });
    if (window.location.hash === '#contents' && drawer) openContents();

    // D. Dock jump menu, built from the same links
    var jump = $('[data-dock-jump]'), jumpBtn = jump && $('.dock__jump-btn', jump), menu = jump && $('.dock__menu', jump);
    if (jump && items.length) {
      jump.hidden = false;
      var ordered = items.filter(function (x) { return !x.num; }).concat(items.filter(function (x) { return x.num; }));
      var contactLink = nav && $('.secnav__contact', nav);
      menu.innerHTML = ordered.map(function (x) {
        return '<li><a href="#' + x.id + '" data-dock-link="' + x.id + '"><em>' + x.num + '</em>' + x.label + '</a></li>';
      }).join('') + (contactLink ? '<li class="dock__menu-sep" aria-hidden="true"></li><li><a href="' + contactLink.getAttribute('href') + '"><em></em>' + contactLink.textContent.trim() + '</a></li>' : '');
      var setMenu = function (open) { menu.hidden = !open; jumpBtn.setAttribute('aria-expanded', String(open)); };
      jumpBtn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(menu.hidden); });
      menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
      document.addEventListener('click', function (e) { if (!jump.contains(e.target)) setMenu(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    }

    // B (phones). Tapping the thin progress line opens the full section list
    var secMenu = nav && $('[data-secnav-menu]', nav), secToggle = nav && $('[data-secnav-toggle]', nav);
    if (secMenu && secToggle && items.length) {
      var longLabel = function (x) {
        var li = drawer && $('[data-contents-item="' + x.id + '"] span', drawer);
        return li ? li.textContent.trim() : x.label;
      };
      var priceEl = $('[data-sticky-price]');
      var secOrdered = items.filter(function (x) { return !x.num; }).concat(items.filter(function (x) { return x.num; }));
      var contactA = $('.secnav__contact', nav);
      secMenu.innerHTML = secOrdered.map(function (x) {
        var shop = !x.num && x.id === 'buy';
        var lead = shop ? (priceEl ? priceEl.textContent.split('·')[0].trim() : '') : x.num;
        return '<li class="' + (shop ? 'is-shop' : '') + '"><a href="#' + x.id + '" data-secmenu-link="' + x.id + '"><em>' + lead + '</em>' + longLabel(x) + '<small></small></a></li>';
      }).join('') + (contactA ? '<li class="is-contact"><a href="' + contactA.getAttribute('href') + '"><em></em>' + contactA.textContent.trim() + '<small>→</small></a></li>' : '');
      // price sits after the label for the shop row
      $$('.is-shop a', secMenu).forEach(function (a) { var em = $('em', a); if (em && em.textContent) { var sm = $('small', a); sm.textContent = em.textContent; sm.style.color = 'inherit'; sm.style.fontSize = '.8125rem'; sm.style.letterSpacing = '0'; em.textContent = ''; } });
      var setSec = function (open) { secMenu.hidden = !open; secToggle.setAttribute('aria-expanded', String(open)); };
      secToggle.addEventListener('click', function (e) { e.stopPropagation(); setSec(secMenu.hidden); });
      secMenu.addEventListener('click', function (e) { if (e.target.closest('a')) setSec(false); });
      document.addEventListener('click', function (e) { if (!nav.contains(e.target)) setSec(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSec(false); });
    }

    if (!items.length) return;
    var fill = nav && $('[data-secnav-fill]', nav), current = $('[data-secnav-cur]') || (nav && $('[data-secnav-current]', nav));
    var activeIdx = -2, ticking = false;
    var centerX = function (x) { var d = $('.secnav__dot', x.a).getBoundingClientRect(), l = $('.secnav__list', nav).getBoundingClientRect(); return d.left + d.width / 2 - l.left; };
    var update = function () {
      ticking = false;
      var line = window.innerHeight * 0.35, idx = -1;
      items.forEach(function (x, i) { if (x.el.getBoundingClientRect().top <= line) idx = i; });
      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 4) idx = items.length - 1;
      // progress within the current section, for a smooth fill
      var frac = 0;
      if (idx >= 0 && idx < items.length - 1) {
        var a = items[idx].el.getBoundingClientRect().top, b = items[idx + 1].el.getBoundingClientRect().top;
        frac = Math.max(0, Math.min(1, (line - a) / Math.max(1, b - a)));
      }
      if (fill) {
        var w = 0;
        if (idx >= 0) { w = centerX(items[idx]); if (idx < items.length - 1) w += (centerX(items[idx + 1]) - w) * frac; }
        fill.style.width = w + 'px';
      }
      if (idx !== activeIdx) {
        activeIdx = idx;
        items.forEach(function (x, i) {
          x.a.setAttribute('aria-current', String(i === idx));
          x.a.classList.toggle('is-done', i < idx);
        });
        var act = items[idx];
        if (current) current.innerHTML = act ? (act.num ? '<em>' + act.num + '</em>' : '') + act.label : '';
        if (jumpBtn) {
          $('[data-dock-num]', jumpBtn).textContent = act ? act.num : '';
          $('[data-dock-label]', jumpBtn).textContent = act ? act.label : 'Jump to';
          $$('a', menu).forEach(function (m) { m.setAttribute('aria-current', String(!!act && m.getAttribute('data-dock-link') === act.id)); });
        }
        if (secMenu) $$('[data-secmenu-link]', secMenu).forEach(function (m) {
          var on = !!act && m.getAttribute('data-secmenu-link') === act.id;
          m.setAttribute('aria-current', String(on));
          if (!m.closest('.is-shop')) $('small', m).textContent = on ? 'Here' : '';
        });
        if (drawer) $$('[data-contents-item] a', drawer).forEach(function (m) { m.setAttribute('aria-current', String(!!act && m.getAttribute('href') === '#' + act.id)); });
      }
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  /* ---------- Phone helpers ---------- */
  // Bottom bar waits until the hero's Shop button has scrolled away
  (function () {
    var heroCta = $('.hero__ctas');
    if (!heroCta || !$('[data-sticky-atc]') || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { document.body.classList.toggle('dock-tucked', e.isIntersecting || e.boundingClientRect.top > 0); });
    });
    io.observe(heroCta);
  })();
  // Swipe the product photo to move through the gallery
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g), x0 = null, y0 = null;
    if (!main) return;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var thumbs = $$('[data-gallery-thumb]', g), cur = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      var next = thumbs[(Math.max(0, cur) + (dx < 0 ? 1 : thumbs.length - 1)) % thumbs.length];
      if (next) next.click();
    });
  });
  // Step cards: counter follows the swipe
  $$('[data-steps]').forEach(function (list) {
    var wrap = list.parentNode, count = $('[data-steps-count]', wrap), bars = $$('.steps-pager__bars i', wrap), steps = $$('.step', list);
    if (!count || !steps.length) return;
    var upd = function () {
      var l = list.getBoundingClientRect().left, best = 0, bd = Infinity;
      steps.forEach(function (st, i) { var d = Math.abs(st.getBoundingClientRect().left - l); if (d < bd) { bd = d; best = i; } });
      count.textContent = (best + 1) + ' / ' + steps.length;
      bars.forEach(function (b, i) { b.classList.toggle('is-on', i === best); });
    };
    list.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
  });
  // Checker: on phones, bring the answer into view after a choice
  $$('[data-checker]').forEach(function (box) {
    box.addEventListener('click', function (e) {
      if (!e.target.closest('[data-metal]') || window.innerWidth > 640) return;
      var v = $('.verdict', box);
      setTimeout(function () { var r = v.getBoundingClientRect(); if (r.bottom > window.innerHeight - 70) v.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
    });
  });

  /* ---------- Sparkle: glints that wander across silver surfaces ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('[data-sparkle]').forEach(function (host) {
      var n = Math.min(16, Number(host.getAttribute('data-sparkle')) || 4);
      var layer = document.createElement('div'); layer.className = 'glint-layer'; layer.setAttribute('aria-hidden', 'true');
      var place = function (g) {
        g.style.left = (12 + Math.random() * 76) + '%';
        g.style.top = (12 + Math.random() * 76) + '%';
      };
      for (var i = 0; i < n; i++) {
        var g = document.createElement('span'); g.className = 'glint';
        g.style.setProperty('--s', (8 + Math.random() * 14).toFixed(1) + 'px');
        g.style.setProperty('--d', (2.8 + Math.random() * 2.6).toFixed(2) + 's');
        g.style.setProperty('--delay', (Math.random() * 4).toFixed(2) + 's');
        place(g);
        g.addEventListener('animationiteration', function (e) { place(e.target); });
        layer.appendChild(g);
      }
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(layer);
    });
  }

  /* ---------- Hero product thumbnails / gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-gallery-thumb]', g).forEach(function (o) { o.setAttribute('aria-current', String(o === t)); });
        var tpl = $('template', t);
        main.innerHTML = tpl ? tpl.innerHTML : t.innerHTML;
      });
    });
  });
})();
